<script>
import { mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';

const SERVICES = [
  {
    id: 1,
    name: 'Страхование'
  },
  {
    id: 2,
    name: 'Кредитование'
  },
  {
    id: 3,
    name: 'Удаленное урегулирование убытков'
  }
]

export default {
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      name: null,
      phone: null,
      service: null,
    };
  },
  SERVICES,
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      service: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
    };
  },
  computed: {
    formData() {
      return {
        name: this.name,
        phone: this.phone,
        email: this.email,
        service: this.service.name,
        action: 'services',
      };
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send'
     }),

    onSubmit(value, actions) {
      this.send(this.formData);

      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.name = null;
      this.phone = null;
      this.service = null;
    },
  },
};
</script>

<template>
  <div class="py-0 px-4 sm:py-4 sm:px-7 lg:py-14 lg:px-20 lg:border-2 lg:border-green lg:rounded-big-brand bg-white">
    <div class="max-w-[768px] lg:max-w-none mx-auto py-4 lg:py-0">
      <vee-form
        :validation-schema="schema"
        novalidate
        class="grid grid-col-1 sm:grid-col-2 lg:grid-col-3 gap-x-5 gap-y-5"
        @submit="onSubmit"
      >
        <div class="grid grid-cols-1 sm:grid-cols-2 sm:col-span-2 lg:grid-cols-3 lg:col-span-3 w-full gap-x-5 gap-y-5">
          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="name"
          >
            <v-input
              v-model="name"
              placeholder="Ваше имя"
              theme="white"
              format="name"
              inscription="Имя*"
              name="name"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="phone"
          >
            <v-input
              v-model="phone"
              placeholder="+7 (___) ___-__-__"
              theme="white"
              format="phone"
              inscription="Телефон*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="service"
          >
            <v-select
              v-model="service"
              :options="$options.SERVICES"
              placeholder="Укажите услугу*"
              theme="white"
              inscription="Услуга*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>
        </div>

        <div class="col-auto sm:col-start-1 sm:col-end-2 lg:col-start-2 lg:col-end-3">
          <button
            type="submit"
            class="button button_green button_big w-full md:col-span-2"
          >Получить консультацию</button>
        </div>
      </vee-form>
    </div>
  </div>
</template>

